import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import labelRequest from '../labelRequest';

export default function getUserDetails(params) {
    const { baseUrl, brandId, country, uberToken, clientId, clientSecret } = params;

    invariant(baseUrl, 'baseUrl is a required param of getUserDeatils()');
    invariant(brandId, 'brandId is a required param of getUserDetails()');
    invariant(country, 'country is a required param of getUserDetails()');
    invariant(uberToken, 'uberToken is a required param of getUserDetails()');
    invariant(clientId, 'clientId is a required param of getUserDetails()');

    const headers = { 'Content-Type': 'application/json' };
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/person/@self`;

    return labelRequest(authenticatedRequest(new Request(url, { headers: new Headers(headers) }), uberToken, clientId, clientSecret), 'getUserDetails');
}
